import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import DateContextProvider from 'src/contexts/date-context';
import { getActiveClient } from 'src/_core/config/clientSelector';
// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));

// PRODUCT

// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const DashboardWorkRequest = lazy(() => import('src/pages/dashboard/dashboard-work-request-page'));
const CreateNewWorkRequest = lazy(() => import('src/pages/dashboard/create-new-work-request-form-page'));
const CreateWorkRequestByDepartment = lazy(() => import('src/pages/dashboard/create-work-request-by-department-page'));
const CreateWorkRequestByLocation = lazy(() => import('src/pages/dashboard/create-work-request-by-location-page'));

// BLOG

// JOB

// TOUR

// APP

// ----------------------------------------------------------------------

const activeClient = getActiveClient();

  const DashboardWorkRequestSMCD = lazy(() => import('src/pages/dashboard/dashboard-work-request-page-SMCD'));
  // const CreateNewWorkRequestSMCD = lazy(() => import('src/pages/dashboard/create-new-work-request-form-page-SMCD'));
  // const CreateWorkRequestByDepartmentSMCD = lazy(() => import('src/pages/dashboard/create-work-request-by-department-page-SMCD'));
  // const CreateWorkRequestByLocationSMCD = lazy(() => import('src/pages/dashboard/create-work-request-by-location-page-SMCD'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <DashboardLayout>
        <DateContextProvider>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
        </DateContextProvider>
      </DashboardLayout>
    ),
    children: [
      { element: <IndexPage />, index: true },

      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          
        ],
      },
      {
        path: 'work_request',
        children: [
          { element: activeClient === 'SMCD_CUSTOMIZATION' ? <DashboardWorkRequestSMCD /> : <DashboardWorkRequest />, index: true },
          { path: 'home', element: activeClient === 'SMCD_CUSTOMIZATION' ? <DashboardWorkRequestSMCD /> : <DashboardWorkRequest /> },
          { path: 'new', element: <CreateNewWorkRequest /> },
          { path: 'by_department', element: <CreateWorkRequestByDepartment /> },
          { path: 'by_location', element: <CreateWorkRequestByLocation /> },
        ],
      },
    ],
  },
];
